import { render } from "./BaseSlider.vue?vue&type=template&id=68f3f091&scoped=true"
import script from "./BaseSlider.vue?vue&type=script&lang=js"
export * from "./BaseSlider.vue?vue&type=script&lang=js"

import "./BaseSlider.vue?vue&type=style&index=0&id=68f3f091&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f3f091"]])

export default __exports__